<template>
  <div>
    <b-modal
      v-model="showModal"
      title="Цэсний тохиргоо"
      scrollable
      no-fade
      centered
      size="xl"
      hide-footer
      @hide="cancel()"
    >
      <table
        v-if="rolesReady"
        class="table table-god table table-bordered w-full table-hover"
      >
        <thead>
          <tr>
            <th scope="col" style="width: 60px">№</th>
            <th scope="col">Модул</th>
            <th scope="col">Тайлбар</th>
            <th scope="col" style="width: 60px">
              <!-- <Icon type="ios-more" /> -->
              <feather type="menu"></feather>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(r, i) in roles">
            <tr v-if="isDrawGroup(i)" :key="i + '_grp'">
              <td style="background: #F0F0F0" colspan="4">
                <b v-if="r.locTypeName != null">{{ r.locTypeName }}</b>
                <b v-else>Бусад</b>
              </td>
            </tr>
            <tr :key="i + '_tr'">
              <td scope="row">{{ i + 1 }}</td>
              <td v-html="r.roleName"></td>
              <td v-html="r.description"></td>
              <td class="text-center">
                <button
                  @click="changeRoleButton(r)"
                  :class="
                    `btn mg-l-20 btn-${r.stts ? 'success' : 'default'} btn-xs`
                  "
                >
                  <feather :type="r.stts ? 'check-square' : 'square'"></feather>
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </b-modal>
    <!-- <Modal :transition-names="[]"
      v-model="showModal"
      footer-hide
      fullscreen
      title="Цэсний тохиргоо"
      @on-cancel="cancel"
    >
      

    </Modal>-->
  </div>
</template>

<script>
//import { GetRoles, GetUserRoles, SetUserRoles } from "@/api/user";
import { request } from "@/api/all";

export default {
  name: "mdlUserpassChangeComp",
  props: {
    taskId: {
      type: Number,
      default: () => null
    },
    json: {
      type: Object,
      default: () => null
    },
    isShow: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      rolesReady: false,
      roles: [],
      userRoles: [],
      passModel: {
        taskId: 0,
        locTypeId4: 0,
        new: "",
        userId: ""
      },
      showModal: false
    };
  },
  watch: {
    isShow(newVal) {
      if (newVal) {
        this.passModel = this.json;
        this.showModal = true;
        this.init();
      }
    }
  },
  methods: {
    init() {
      let self = this;
      request({
        api: { method: "get", url: "Auth/GetRoles" },
        store: self.$store
      }).then(res => {
        if (res != false) {
          self.roles = res.data.roles;
          request({
            api: { method: "get", url: "Auth/GetUserRoles" },
            params: {
              userId: self.passModel.userId
            },
            store: self.$store
          }).then(res => {
            //console.log(res);
            if (res != false) {
              self.userRoles = res.data.roles;
              for (var i = 0; i < self.roles.length; i++) {
                self.roles[i].stts =
                  self.userRoles.filter(p => p.roleId == self.roles[i].roleId)
                    .length > 0
                    ? true
                    : false;
                if (i + 1 == self.roles.length) {
                  self.rolesReady = true;
                }
              }
            }
          });
        }
      });
    },
    isDrawGroup(i) {
      if (i == 0) {
        return true;
      } else if (this.roles[i].locTypeId != this.roles[i - 1].locTypeId) {
        return true;
      } else {
        return false;
      }
    },
    changeRoleButton(r) {
      r.stts = !r.stts;
      request({
        api: { method: "post", url: "auth/SetUserRoles" },
        data: {
          userId: this.passModel.userId,
          roles: this.roles.filter(p => p.stts == true)
        },
        store: this.$store
      }).then(res => {
        //console.log(res);
        if (res != false) {
          this.$bvToast.toast("Амжилттай", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true
          });
        }
      });
    },
    cancel() {
      //console.log("close event fired");
      this.showModal = false;
      this.$emit("on-close");
    }
  }
};
</script>

<style></style>
